import { render, staticRenderFns } from "./thematicList.vue?vue&type=template&id=28cc6eb9&scoped=true"
import script from "./thematicList.vue?vue&type=script&lang=js"
export * from "./thematicList.vue?vue&type=script&lang=js"
import style0 from "./thematicList.vue?vue&type=style&index=0&id=28cc6eb9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cc6eb9",
  null
  
)

export default component.exports